const LAUNCH_SEARCH = 'LaunchSearch';
const START_SEARCH = 'StartSearch';
const SEARCH_RESULTS_RENDERED = 'SearchResultsRendered';
const SEARCH_NO_RESULTS_RENDERED = 'SearchNoResultsRendered';
const SEARCH_RESULTS_ERROR = 'SearchResultsError';
const ZERO_QUERY_LAUNCHED = 'ZeroQueryLaunched';
const ZERO_QUERY_RENDERED = 'ZeroQueryRendered';
const SWITCH_SEARCH_TAB = 'SwitchSearchTab';
const CONTACT_SELECTED = 'ContactSelected';
const KEYWORD_SELECTED = 'KeyWordSelected';
const QUERY_SUBMITTED = 'QuerySubmitted';
const SUBSTRATE_REQUEST_START = '3SRequestStart';
const SUBSTRATE_REQUEST_END = '3SRequestEnd';

export {
    LAUNCH_SEARCH,
    START_SEARCH,
    SEARCH_NO_RESULTS_RENDERED,
    SEARCH_RESULTS_RENDERED,
    SEARCH_RESULTS_ERROR,
    ZERO_QUERY_LAUNCHED,
    ZERO_QUERY_RENDERED,
    SWITCH_SEARCH_TAB,
    CONTACT_SELECTED,
    KEYWORD_SELECTED,
    QUERY_SUBMITTED,
    SUBSTRATE_REQUEST_START,
    SUBSTRATE_REQUEST_END,
};
